import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { environment } from "../../../../environments/environment";
import { TaskLot } from "../domains/task-lot";
import { TaskAssignee } from "../domains/task";

@Injectable({ providedIn: "root" })
export class TaskLotService {
  private http = inject(HttpClient);
  private url = environment.apiUrl + "/task-lots";

  getByProject(projectId: string): Observable<TaskLot[]> {
    return this.http.get<TaskLot[]>(`${this.url}?project_id=${projectId}`);
  }

  create(title: string, projectId: string, assignees: TaskAssignee[] = []): Observable<TaskLot> {
    return this.http.post<TaskLot>(this.url, { title, project_id: projectId, assignees });
  }

  rename(lotId: string, title: string): Observable<TaskLot> {
    return this.http.put<TaskLot>(`${this.url}/${lotId}`, { title });
  }

  update(
    lotId: string,
    data: { title?: string; assignees?: TaskAssignee[]; task_ids?: string[] },
  ): Observable<TaskLot> {
    return this.http.put<TaskLot>(`${this.url}/${lotId}`, data);
  }

  delete(lotId: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${lotId}`);
  }

  addTaskToLot(lotId: string, taskId: string): Observable<TaskLot> {
    return this.http.post<TaskLot>(`${this.url}/${lotId}/tasks/${taskId}`, {});
  }

  removeTaskFromLot(lotId: string, taskId: string): Observable<TaskLot> {
    return this.http.delete<TaskLot>(`${this.url}/${lotId}/tasks/${taskId}`);
  }

  reorderLots(projectId: string, lotIds: string[]): Observable<TaskLot[]> {
    return this.http.put<TaskLot[]>(`${this.url}/reorder`, { project_id: projectId, lot_ids: lotIds });
  }

  /** Helper client-side pur — pas d'appel API */
  getLotForTask(taskId: string, lots: TaskLot[]): TaskLot | null {
    return lots.find((l) => l.task_ids.includes(taskId)) ?? null;
  }
}
